const Roles = Object.freeze({
    RECUPERADOR: 2,
    PROMOTOR: 3,
    PROMOTOR_FLORESER: 4,
    COBRADORA_FLORESER: 5,
    GESTOR_FLORESER: 6
})

export default Roles
